module.exports = __webpack_public_path__ + "img/POL.596cbd9d.svg";